<div [class]="currentTheme" class="bg-plus-2">
  @if (!showDetails) {
    <div>
      <h1 mat-dialog-title>{{ 'GENERAL.ONLINE_CREDIT.GENERATE' | translate }}</h1>
      <form [formGroup]="form" class="form" (submit)="search()" autocomplete="off">
        <div mat-dialog-content>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'GENERAL.ONLINE_CREDIT.VALUE' | translate | titlecase }}</mat-label>
            <input matInput formControlName="value" class="input-upper" type="number" name="value" />
            @if (hasError('value')) {
              <mat-error>{{ getErrorMessage('value').label | translate: getErrorMessage('value').values }}</mat-error>
            }
          </mat-form-field>
        </div>
        <div mat-dialog-content>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'GENERAL.ONLINE_CREDIT.PIN' | translate | titlecase }}</mat-label>
            <input matInput formControlName="pin" class="input-upper" type="password" name="pin" autocomplete="off" />
            @if (hasError('pin')) {
              <mat-error>{{ getErrorMessage('pin').label | translate: getErrorMessage('pin').values }}</mat-error>
            }
          </mat-form-field>
        </div>
        <div mat-dialog-content>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'GENERAL.ONLINE_CREDIT.CONFIRM_PIN' | translate | titlecase }}</mat-label>
            <input matInput formControlName="confirm_pin" class="input-upper" type="password" name="confirm_pin" autocomplete="off" />
            @if (hasError('confirm_pin')) {
              <mat-error>{{
                getErrorMessage('confirm_pin').label | translate: getErrorMessage('confirm_pin').values
              }}</mat-error>
            }
          </mat-form-field>
        </div>
        <div mat-dialog-actions>
          <button class="cancel" mat-button type="button" (click)="onNoClick()">{{ 'GENERAL.CANCEL' | translate }}</button>
          <button class="confirm" mat-button type="submit">{{ 'GENERAL.ONLINE_CREDIT.GENERATE_LABEL' | translate }}</button>
        </div>
      </form>
    </div>
  }

  @if (showDetails) {
    <div>
      <h1 mat-dialog-title>{{ 'GENERAL.ONLINE_CREDIT.GENERATED' | translate }}</h1>
      <div mat-dialog-content [class]="currentTheme">
        <div class="content-name">
          <span>{{ 'GENERAL.CODE' | translate }}</span>
          <span class="name color-primary" style="padding-left: 5px">{{ this.credit.code | mask: 'AAA-AAA-AAA' }}</span>
        </div>
        <div class="content-name">
          <span>{{ 'GENERAL.VALUE' | translate }}</span>
          <span class="name color-primary" style="padding-left: 5px">{{ this.credit.value | currencycase }}</span>
        </div>
        <div class="content-name">
          <span>{{ 'GENERAL.DATE' | translate }}</span>
          <span class="name color-primary" style="padding-left: 5px">{{ this.credit.created_at | date: 'dd/MM/yyyy - HH:mm' }}</span>
        </div>
      </div>
      <div mat-dialog-actions class="separated-actions">
        <div>
          <button class="print" mat-button (click)="printCredit()">{{ 'GENERAL.PRINT' | translate }}</button>
          <button class="print" mat-button (click)="shareInWhatsapp()">{{ 'GENERAL.ONLINE_CREDIT.SHARE' | translate }}</button>
        </div>
        <button class="confirm" mat-button (click)="onNoClick()">{{ 'GENERAL.CLOSE' | translate }}</button>
      </div>
    </div>
  }
</div>
